var packageComponent;
$(document).ready(function() {
	if(!document.querySelector('.GPC0010')) return false;

	packageComponent = {
		el: document.querySelector('.GPC0010'),
		els: {
			totalPrice: null,
			selectedNumber: null
		},
		// PJTOBS-31 Start
		ajaxUrl: null,
		// PJTOBS-31 End
		initialPrice: 0,
		slick: {
			$slideTarget: null,
			init: function(){
				var _slick = this;
				_slick.$slideTarget = $(packageComponent.el).find('.package-content');
				for(var i=0;i<_slick.$slideTarget.length;i++) {
					var _currentSlick = _slick.$slideTarget.eq(i);
					_currentSlick.slick({
						listStyle: true, // WA-GPC0010-03
						infinite: false,
						slidesToShow: 3,
						slidesToScroll: 3,
						nextArrow: _currentSlick.parent().find('.package-next'),
						prevArrow: _currentSlick.parent().find('.package-prev'),
						dots:false,
						appendDots: _currentSlick.parent().find('.slick-dot-wrap'),
						responsive: [
							{
								breakpoint: 1284,
								settings: {
									slidesToShow: 2,
									slidesToScroll: 2
								}
							},
							{
							  breakpoint: 768,
							  settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
								arrows: false,
								dots:true,
							  }
							}
						]
					});
				}
			}
		},
		init: function(){
			var _this = this;
			_this.els.totalPrice = _this.el.querySelector('.total-price');
			_this.els.selectedNumber = _this.el.querySelector('.selected-number .number');
			_this.initialPrice = $('.GPC0009 .price-area:visible').eq(0).attr('data-original-price') ? parseFloat($('.GPC0009 .price-area:visible').eq(0).attr('data-original-price')) : 0;

			// PJTOBS-31 Start
			// template
			var template = '<div>'+$(_this.el).find('template').clone().html()+'</div>';
			$(_this.el).data('template', template);
			_this.ajaxUrl = $(_this.el).find('template').attr('data-ajax-url');
			$(_this.el).find('template').remove();

			// button
			$(_this.el).find('.add-to-cart-multi').addClass('disabled');

			// show/hide
			var visibleLen = $(_this.el).find('.tab-wrap .js-tab li').not('[hidden]').length;
			if(visibleLen==0) {
				$(_this.el).attr('hidden', true);
			} else if(visibleLen==1) {
				$(_this.el).removeAttr('hidden');
				$(packageComponent.el).find('.tab-wrap').attr('hidden', true);
			} else {
				$(_this.el).removeAttr('hidden');
			}

			// init pincode
			if($('#check-pincode').length>0) {
				$('.GPC0010 .products-list-wrap input[type="checkbox"]').attr('disabled', true);
				$('.GPC0010 .products-list-wrap input[type="radio"]').attr('disabled', true);
			}

			// PJTOBS-31 End

			_this.slick.init();
			_this.addEvent();

		},
		// PJTOBS-31 Start
		sumPrice: function(e){
			var _this = packageComponent,
				len = 0,
				sum = 0;

			var $checkbox = _this.el.querySelectorAll('input[type="checkbox"]:checked'),
				$radiobox = _this.el.querySelectorAll('input[type="radio"]:checked');

			if($checkbox.length>0) {
				for (var i = 0; i < $checkbox.length; i++) {
					var val = parseFloat($checkbox[i].value) || 0;
					sum = parseFloat((sum + val).toFixed(2)); // fix js bug (js bug /13349.96+2999.99 = 16349.949999999999)
					len ++;
				}
			}
			if($radiobox.length>0) {
				for (var i = 0; i < $radiobox.length; i++) {
					var val = parseFloat($radiobox[i].value) || 0;
					sum = parseFloat((sum + val).toFixed(2)); // fix js bug
					if(val != 0) len ++;
				}
			}
			sum = (sum + _this.initialPrice).toFixed(2); // fix js bug
			//console.log(sum);
			var price = String(sum).split('.')[0],
				priceCent = String(sum).split('.')[1] ? String(sum).split('.')[1] : '';

			if(priceCent=='00') priceCent = '';

			//console.log(changeFormatFullPrice(price, priceCent));
			$(_this.els.totalPrice).find('.num').text(changeFormatFullPrice(price, priceCent));
			$(_this.els.selectedNumber).text(len);

			if(len==0) {
				$(_this.el).find('.add-to-cart-multi').addClass('disabled');
				$(_this.els.totalPrice).find('.num').text('0');
			} else {
				$(_this.el).find('.add-to-cart-multi').removeClass('disabled');
			}
		},
		getMultiModelId: function() {
			var _this = packageComponent;
			var $cont = _this.el;
			var $checkbox = $cont.querySelectorAll('input[type="checkbox"]:checked'),
				$radiobox = $cont.querySelectorAll('input[type="radio"]:checked'),
				modelId = $(_this.el).find('.add-to-cart-multi').attr('data-model-id');
			if($checkbox.length>0) {
				for (var i = 0; i < $checkbox.length; i++) {
					var currentId = $($checkbox[i]).attr('data-model-id');
					if(!!currentId) {
						if(modelId=='') modelId = currentId;
						else modelId = modelId + ','+currentId;
					}
				}
			}
			if($radiobox.length>0) {
				for (var i = 0; i < $radiobox.length; i++) {
					var currentId2 = $($radiobox[i]).attr('data-model-id');
					if(!!currentId2) {
						if(modelId=='') modelId = currentId2;
						else modelId = modelId + ','+currentId2;
					}
				}
			}
			return modelId;
		},
		setCheckbox: function(tab, $obj, rPrice, rPriceCent, rPromoPrice, rPromoPriceCent) {
			var calPrice = 0;
			if(tab == 'bundle-offer' || tab == 'accessories') {
				if(rPromoPrice != null) {
					if(rPromoPriceCent == null) {
						calPrice = parseInt(rPromoPrice);
					} else {
						calPrice = parseInt(rPromoPrice) + '.' + parseInt(rPromoPriceCent);
					}
				} else {
					if(rPriceCent == null) {
						calPrice = parseInt(rPrice);
					} else {
						calPrice = parseInt(rPrice) + '.' + parseInt(rPriceCent);
					}
				}
				if(calPrice == 0) {
					$obj.attr('value', calPrice).attr('disabled', true);
				} else {
					if($('#check-pincode').length>0 && $('.GPC0009 .check-good').length==0) { // for in
						$obj.attr('value', calPrice).attr('disabled', true);
					} else {
						$obj.attr('value', calPrice).removeAttr('disabled');
					}
				}
			} else if(tab == 'warranty') {
				// warranty
				if(rPriceCent == null) {
					//console.log('1');
					calPrice = parseInt(rPrice);
				} else {
					//console.log('2');
					calPrice = parseInt(rPrice) + '.' + parseInt(rPriceCent);
				}
				//console.log('3');
				$obj.attr('value', calPrice);
			}
			//console.log(tab, $obj, calPrice, rPrice, rPriceCent, rPromoPrice, rPromoPriceCent);
		},
		applyVIPPrice: function() {
			var _this = this;
			var mId = $('.GPC0009').attr('data-product-id'); // LGEPL-697

			// ajax
			ajax.call(_this.ajaxUrl, {modelId:mId}, 'json', function(data){
				var p = data.data[0];
				if(p.products.length > 0) {
					for(var i=0;i<p.products.length;i++) { // LGEPL-697
						var product = p.products[i];
						if(product.vipPriceFlag == 'Y') { // LGEPL-697
							var target = $(packageComponent.el).find('.products-list-wrap .bundle-offer input[data-model-id='+product.modelId+']').closest('.item').find('.price-area');
							var priceOrg = changeFormatFullPrice(product.rPrice, product.rPriceCent);
							var pricePromo = changeFormatFullPrice(product.rPromoPrice, product.rPromoPriceCent);
							var legal = product.discountMsg == null ? '' : product.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');		// LGEIS-229 change how discounts are shown
							var vipPriceText = product.productMessages.vipPriceMessage;
							//LGEMS-432 Start
							if(COUNTRY_CODE.toLowerCase() == 'mx' && 'B2B' == $('.navigation').attr('data-obs-group')){
								vipPriceText = product.productMessages.b2bVipPriceMessage;
							}
							//LGEMS-432 End
							var previousPriceText = product.productMessages.previousPriceText;
							setVipPrice(target, priceOrg, pricePromo, legal, vipPriceText, previousPriceText, product.modelId + '/' + 'GPC0010.js', '', '', '', ''); // LGCOMMON-54

							// checkbox
							var $obj = $(packageComponent.el).find('.products-list-wrap .bundle-offer input[data-model-id='+product.modelId+']');
							packageComponent.setCheckbox('bundle-offer', $obj, product.rPrice, product.rPriceCent, product.rPromoPrice, product.rPromoPriceCent);
						} else {
							// !(vip price)
							var target = $(packageComponent.el).find('.products-list-wrap .bundle-offer input[data-model-id='+product.modelId+']');
							if(target.closest('.item').find('.price-area .purchase-price').length==0) {
								target.attr('disabled', true);
							}
						}
					}
				}
				if(p.accessories.length > 0) {
					for(var j=0;j<p.accessories;j++) {
						var product = p.accessories[i];
						if(product.vipPriceFlag == 'Y') { // LGEPL-697
							var target = $(packageComponent.el).find('.products-list-wrap .accessories input[data-model-id='+product.modelId+']').closest('.item').find('.price-area');
							var priceOrg = changeFormatFullPrice(product.rPrice, product.rPriceCent);
							var pricePromo = changeFormatFullPrice(product.rPromoPrice, product.rPromoPriceCent);
							var legal = product.discountMsg == null ? '' : product.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');		// LGEIS-229 change how discounts are shown
							var vipPriceText = product.productMessages.vipPriceMessage;
							//LGEMS-432 Start
							if(COUNTRY_CODE.toLowerCase() == 'mx' && 'B2B' == $('.navigation').attr('data-obs-group')){
								vipPriceText = product.productMessages.b2bVipPriceMessage;
							}
							//LGEMS-432 End
							var previousPriceText = product.productMessages.previousPriceText;
							
							// price
							setVipPrice(target, priceOrg, pricePromo, legal, vipPriceText, previousPriceText, product.modelId + '/' + 'GPC0010.js', '', '', '', ''); // LGCOMMON-54

							// checkbox
							var $obj = $(packageComponent.el).find('.products-list-wrap .accessories input[data-model-id='+product.modelId+']');
							packageComponent.setCheckbox('accessories', $obj, product.rPrice, product.rPriceCent, product.rPromoPrice, product.rPromoPriceCent);
						} else {
							// !(vip price)
							var target = $(packageComponent.el).find('.products-list-wrap .accessories input[data-model-id='+product.modelId+']');
							if(target.closest('.item').find('.price-area .purchase-price').length==0) {
								target.attr('disabled', true);
							}
						}
					}
				}
				if(p.warranty.length > 0) {
					for(var k=0;k<p.warranty;k++) {
						var product = p.warranty[i];
						if(product.vipPriceFlag == 'Y') { // LGEPL-697
							var target = $(packageComponent.el).find('.products-list-wrap .warranty input[data-model-id='+product.modelId+']').closest('.item').find('.price-area');
							var priceOrg = changeFormatFullPrice(product.rPrice, product.rPriceCent);
							// price
							var templateAll = $(packageComponent.el).data('template');
							var temp = $(templateAll).find('.warranty li .text').clone().html();
							temp = temp
								.replace(/\*description\*/g, product.description)
								.replace(/\*rPrice\*\.\*rPriceCent\*/g, product.rPrice ? changeFormatFullPrice(product.rPrice, product.rPriceCent) : 'null')
								.replace(/\*rPrice\*/g, product.rPrice ? changeFormatPrice(product.rPrice) : 'null')
								.replace(/\*rPriceCent\*/g, product.rPriceCent ? (product.rPriceCent) : 'null')
								;

							// checkbox
							var $obj = $(packageComponent.el).find('.products-list-wrap .warranty input[data-model-id='+product.modelId+']').attr('value', calPrice);
							packageComponent.setCheckbox('warranty', $obj, product.rPrice, product.rPriceCent, product.rPromoPrice, product.rPromoPriceCent);
							if(d.rPrice == null || d.rPrice == '') {
								$temp.find('.text').text(d.description);
							}
						}
					}				
				}
			}, commonSendType);
		},
		changeSubModel: function(modelId) {
			// 9번 컴포넌트에서 siblings 클릭시, 10번 컴포넌트가 변경되는 경우
			var _this = this;
			var template = $(_this.el).data('template'); // html type
			ajax.call(_this.ajaxUrl, {modelId:modelId}, 'json', function(data){
				var p = data.data[0];
				var firstItem = 0;
				$(_this.el).find('.package-content').slick('unslick');

				if(p.products.length > 0) {
					if(firstItem == 0) firstItem = 1;
					// tab
					$(_this.el).find('.tab-wrap li.bundle-offer').removeAttr('hidden');
					// change html
					var tempHTML = '';
					for(var i=0;i<p.products.length;i++) {
						var temp = $(template).find('.bundle-offer').clone().html();
						var d = p.products[i];
						temp = temp
							.replace(/\*idx\*/g, parseInt(i+1))
							.replace(/\*modelId\*/g, d.modelId)
							.replace(/\*modelName\*/g, d.modelName)
							.replace(/\*userFriendlyName\*/g, d.userFriendlyName ? d.userFriendlyName : '')
							.replace(/\*modelUrlPath\*/g, d.modelUrlPath)
							.replace(/\*salesModelCode\*/g, d.salesModelCode)
							.replace(/\*salesSuffixCode\*/g, (d.salesSuffixCode || ''))
							.replace(/\*mediumImageAddr\*/g, d.mediumImageAddr)
							.replace(/\*imageAltText\*/g, d.imageAltText ? d.imageAltText : '')
							.replace(/\*rPrice\*\.\*rPriceCent\*/g, d.rPrice ? changeFormatFullPrice(d.rPrice, d.rPriceCent) : 'null')
							.replace(/\*rPromoPrice\*\.\*rPromoPriceCent\*/g, d.rPromoPrice ? changeFormatFullPrice(d.rPromoPrice, d.rPromoPriceCent) : 'null')
							.replace(/\*rPrice\*/g, d.rPrice ? changeFormatPrice(d.rPrice) : 'null')
							.replace(/\*rPromoPrice\*/g, d.rPromoPrice ? changeFormatPrice(d.rPromoPrice) : 'null')
							.replace(/\*rPriceCent\*/g, d.rPriceCent ? (d.rPriceCent) : 'null')
							.replace(/\*rPromoPriceCent\*/g, d.rPromoPriceCent ? (d.rPromoPriceCent) : 'null')
							.replace(/\*discountedRate\*/g, d.discountedRate)
							.replace(/\*discountMsg\*/g, d.discountMsg == null ? '' : d.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>'))		// LGEIS-229 change how discounts are shown
							.replace(/\*retailerPricingText\*/g, d.retailerPricingText)
							;

						var $temp = $(temp);

						// price setting
						var $prices = $temp.find('.price-area');
						if(d.retailerPricingFlag=="Y") {
							$prices.filter('.rPrice').remove();
							$prices.filter('.rPromoPrice').remove();
						}else {
							if((d.rPromoPrice && d.rPromoPrice != null) && (d.rPrice && d.rPrice != null)) {
								$prices.filter('.rPrice').remove();
								$prices.filter('.retailer').remove();
							}else if(d.rPrice && d.rPrice != null){
								$prices.filter('.rPromoPrice').remove();
								$prices.filter('.retailer').remove();
							}else {
								$prices.filter('.rPrice').html("");
								$prices.filter('.rPromoPrice').remove();
								$prices.filter('.retailer').remove();
							}
						}

						// vip price
						if(ISVIP) $prices.addClass('vip-price-area');
						if(d.vipPriceFlag == 'Y') {
							var priceOrg = changeFormatFullPrice(d.rPrice, d.rPriceCent);
							var pricePromo = changeFormatFullPrice(d.rPromoPrice, d.rPromoPriceCent);
							var legal = d.discountMsg == null ? '' : d.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');		// LGEIS-229 change how discounts are shown
							var vipPriceText = d.productMessages.vipPriceMessage;
							//LGEMS-432 Start
							if(COUNTRY_CODE.toLowerCase() == 'mx' && 'B2B' == $('.navigation').attr('data-obs-group')){
								vipPriceText = d.productMessages.b2bVipPriceMessage;
							}
							//LGEMS-432 End
							var previousPriceText = d.productMessages.previousPriceText;
							setVipPrice($prices, priceOrg, pricePromo, legal, vipPriceText, previousPriceText, d.modelId + '/' + 'GPC0010.js', '', '', '', ''); // LGCOMMON-54
						}

						// LGCOMPL-218 start
						if ( d.obsLowestPriceFlag == 'Y' && !!d.rPromoPrice ) {
							if ( $temp.find('.lowest-price-mark').length ) $temp.find('.lowest-price-mark').removeClass('d-none');
							if ( $temp.find('.lowest-price-box').length ) $temp.find('.lowest-price-box').removeClass('d-none'); 
						} else {
							if ( $temp.find('.lowest-price-mark').length ) $temp.find('.lowest-price-mark').html('');
							if ( $temp.find('.lowest-price-box').length ) $temp.find('.lowest-price-box').html('');
						}
						// LGCOMPL-218 end

						// checkbox
						var $obj = $temp.find('.checkbox-box input[data-model-id='+d.modelId+']');
						_this.setCheckbox('bundle-offer', $obj, d.rPrice, d.rPriceCent, d.rPromoPrice, d.rPromoPriceCent);

						temp = $temp.get(0).outerHTML;
						tempHTML = tempHTML + temp;
					}
					$(_this.el).find('.products-list-wrap .tabs-cont.bundle-offer .package-content').html(tempHTML);
				} else {
					// tab
					$(_this.el).find('.tab-wrap li.bundle-offer').attr('hidden', true);
				}
				if(p.accessories.length > 0) {
					if(firstItem == 0) firstItem = 2;
					// tab
					$(_this.el).find('.tab-wrap li.accessories').removeAttr('hidden');
					// change html
					var tempHTML = '';
					for(var i=0;i<p.accessories.length;i++) {
						var temp = $(template).find('.accessories').clone().html();
						var d = p.accessories[i];
						temp = temp
							.replace(/\*idx\*/g, parseInt(i+1))
							.replace(/\*modelId\*/g, d.modelId)
							.replace(/\*modelName\*/g, d.modelName)
							.replace(/\*userFriendlyName\*/g, d.userFriendlyName ? d.userFriendlyName : '')
							.replace(/\*modelUrlPath\*/g, d.modelUrlPath)
							.replace(/\*salesModelCode\*/g, d.salesModelCode)
							.replace(/\*salesSuffixCode\*/g, (d.salesSuffixCode || ''))
							.replace(/\*mediumImageAddr\*/g, d.mediumImageAddr)
							.replace(/\*imageAltText\*/g, d.imageAltText ? d.imageAltText : '')
							.replace(/\*rPrice\*\.\*rPriceCent\*/g, d.rPrice ? changeFormatFullPrice(d.rPrice, d.rPriceCent) : 'null')
							.replace(/\*rPromoPrice\*\.\*rPromoPriceCent\*/g, d.rPromoPrice ? changeFormatFullPrice(d.rPromoPrice, d.rPromoPriceCent) : 'null')
							.replace(/\*rPrice\*/g, d.rPrice ? changeFormatPrice(d.rPrice) : 'null')
							.replace(/\*rPromoPrice\*/g, d.rPromoPrice ? changeFormatPrice(d.rPromoPrice) : 'null')
							.replace(/\*rPriceCent\*/g, d.rPriceCent ? (d.rPriceCent) : 'null')
							.replace(/\*rPromoPriceCent\*/g, d.rPromoPriceCent ? (d.rPromoPriceCent) : 'null')
							.replace(/\*discountedRate\*/g, d.discountedRate)
							.replace(/\*discountMsg\*/g, d.discountMsg == null ? '' : d.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>'))		// LGEIS-229 change how discounts are shown
							.replace(/\*retailerPricingText\*/g, d.retailerPricingText)
							;

						var $temp = $(temp);

						// price setting
						var $prices = $temp.find('.price-area');
						if(d.retailerPricingFlag=="Y") {
							$prices.filter('.rPrice').remove();
							$prices.filter('.rPromoPrice').remove();
						}else {
							if((d.rPromoPrice && d.rPromoPrice != null) && (d.rPrice && d.rPrice != null)) {
								$prices.filter('.rPrice').remove();
								$prices.filter('.retailer').remove();
							}else if(d.rPrice && d.rPrice != null){
								$prices.filter('.rPromoPrice').remove();
								$prices.filter('.retailer').remove();
							}else {
								$prices.filter('.rPrice').html("");
								$prices.filter('.rPromoPrice').remove();
								$prices.filter('.retailer').remove();
							}
						}

						// vip price
						if(ISVIP) $prices.addClass('vip-price-area');
						if(d.vipPriceFlag == 'Y') {
							var priceOrg = changeFormatFullPrice(d.rPrice, d.rPriceCent);
							var pricePromo = changeFormatFullPrice(d.rPromoPrice, d.rPromoPriceCent);
							var legal = d.discountMsg == null ? '' : d.discountMsg.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');		// LGEIS-229 change how discounts are shown
							var vipPriceText = d.productMessages.vipPriceMessage;
							//LGEMS-432 Start
							if(COUNTRY_CODE.toLowerCase() == 'mx' && 'B2B' == $('.navigation').attr('data-obs-group')){
								vipPriceText = d.productMessages.b2bVipPriceMessage;
							}
							//LGEMS-432 End
							var previousPriceText = d.productMessages.previousPriceText;
							setVipPrice($prices, priceOrg, pricePromo, legal, vipPriceText, previousPriceText, d.modelId + '/' + 'GPC0010.js', '', '', '', ''); // LGCOMMON-54
						}
						//LGCOMPL-218 start
						if ( d.obsLowestPriceFlag == 'Y' && !!d.rPromoPrice ) {
							if ( $temp.find('.lowest-price-mark').length ) $temp.find('.lowest-price-mark').removeClass('d-none');
							if ( $temp.find('.lowest-price-box').length ) $temp.find('.lowest-price-box').removeClass('d-none'); 
						} else {
							if ( $temp.find('.lowest-price-mark').length ) $temp.find('.lowest-price-mark').html('');
							if ( $temp.find('.lowest-price-box').length ) $temp.find('.lowest-price-box').html('');
						}
						//LGCOMPL-218 end
						// checkbox
						var $obj = $temp.find('.checkbox-box input[data-model-id='+d.modelId+']');
						_this.setCheckbox('accessories', $obj, d.rPrice, d.rPriceCent, d.rPromoPrice, d.rPromoPriceCent);

						temp = $temp.get(0).outerHTML;
						tempHTML = tempHTML + temp;
					}
					$(_this.el).find('.products-list-wrap .tabs-cont.accessories .package-content').html(tempHTML);
				} else {
					// tab
					$(_this.el).find('.tab-wrap li.accessories').attr('hidden', true);
				}
				if(p.warranty.length > 0) {
					if(firstItem == 0) firstItem = 3;
					// tab
					$(_this.el).find('.tab-wrap li.warranty').removeAttr('hidden');
					// change html
					var tempHTML = '';
					var parentsUserFriendlyName = '';
					for(var i=0;i<p.warranty.length;i++) {
						var temp = $(template).find('.warranty').clone().html();
						var d = p.warranty[i];
						temp = temp
							.replace(/\*idx\*/g, parseInt(i+1))
							.replace(/\*modelId\*/g, d.modelId)
							.replace(/\*description\*/g, d.description)
							.replace(/\*rPrice\*\.\*rPriceCent\*/g, d.rPrice ? changeFormatFullPrice(d.rPrice, d.rPriceCent) : 'null')
							.replace(/\*rPrice\*/g, d.rPrice ? changeFormatPrice(d.rPrice) : 'null')
							.replace(/\*rPriceCent\*/g, d.rPriceCent ? (d.rPriceCent) : 'null')
							;
						if(d.parentsUserFriendlyName != null) parentsUserFriendlyName = d.parentsUserFriendlyName;

						var $temp = $(temp);

						// checkbox
						var $obj = $temp.find('.radio-box input[data-model-id='+d.modelId+']');
						_this.setCheckbox('warranty', $obj, d.rPrice, d.rPriceCent, d.rPromoPrice, d.rPromoPriceCent);
						if(d.rPrice == null || d.rPrice == '') {
							$temp.find('.text').text(d.description);
						}

						temp = $temp.get(0).outerHTML;
						tempHTML = tempHTML + temp;
					}
					$(_this.el).find('.products-list-wrap .tabs-cont.warranty .solutions-contents .user-friendly-name').text(parentsUserFriendlyName);
					$(_this.el).find('.products-list-wrap .tabs-cont.warranty .radio-list').html(tempHTML);
					$(_this.el).find('.products-list-wrap .tabs-cont.warranty .radio-list li:first-child input').prop('checked', true);
				} else {
					// tab
					$(_this.el).find('.tab-wrap li.warranty').attr('hidden', true);
				}

				$(_this.el).find('.add-to-cart-multi').addClass('disabled');

				// 첫 화면에서 보여줄 tab 과 panel 선택
				var firstObj, firstTab;
				$(_this.el).removeAttr('hidden');
				$(_this.el).find('.tab-wrap').removeAttr('hidden');
				if(firstItem == 1) {
					firstTab = $(_this.el).find('.tab-wrap li.bundle-offer');
					firstObj = firstTab.find('a').attr('aria-controls'); // packagePanel_1
				} else if(firstItem == 2) {
					firstTab = $(_this.el).find('.tab-wrap li.accessories');
					firstObj = firstTab.find('a').attr('aria-controls'); // packagePanel_2
				} else if(firstItem == 3) {
					firstTab = $(_this.el).find('.tab-wrap li.warranty');
					firstObj = firstTab.find('a').attr('aria-controls'); // packagePanel_3
				} else {
					$(_this.el).find('.tab-wrap').attr('hidden', true);
					$(_this.el).attr('hidden', true);
				}
				if(!!firstTab && !!firstObj) {
					//tab 
					$(_this.el).find('.tab-wrap li a.btn-tab').removeClass('active');
					firstTab.find('a.btn-tab').addClass('active');
					//panel
					if($('#'+firstObj).length>0) {
						$('#'+firstObj).addClass('active').siblings().removeClass('active');
					}
				}

				var visibleLen = $(_this.el).find('.tab-wrap .js-tab li').not('[hidden]').length;
				if(visibleLen==0) {
					$(_this.el).attr('hidden', true);
				} else if(visibleLen==1) {
					$(_this.el).find('.tab-wrap').attr('hidden', true);
				}

				// init pincode
				if($('#check-pincode').length>0) {
					$('.GPC0010 .products-list-wrap input[type="checkbox"]').attr('disabled', true);
					$('.GPC0010 .products-list-wrap input[type="radio"]').attr('disabled', true);
				}
				
				// run Slick
				_this.slick.init();

			}, commonSendType);

			$(_this.el).find('.add-to-cart-multi').attr('data-model-id', modelId);
			$(_this.els.totalPrice).find('.num').text('0');
			$(_this.els.selectedNumber).text(0);
		},
		// PJTOBS-31 End
		addEvent: function(){
			var _this = this;

			if(ISVIP) _this.applyVIPPrice(); // LGEPL-697

			$(_this.el).on({
				change: _this.sumPrice
			}, 'input[type="checkbox"]');
			$(_this.el).on({
				change: _this.sumPrice
			}, 'input[type="radio"]');

			// add-to-cart-multi 클릭시 실행할 스크립트는 add-to-cart.js 에 있습니다.
		}
	};
	packageComponent.init();
});
